import React from "react";
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Leagues from '../pages/Leagues';
import League from '../pages/League';
import Seasons from '../pages/Seasons';
import Season from '../pages/Season';
import Stage from '../pages/Stage';
import ImportStageResults from "../pages/ImportStageResults/";
import Player from '../pages/Player';
import Ranking from '../pages/Ranking';
import FilteredTournaments from '../pages/FilteredTournaments';
import Tournaments from '../pages/Tournaments';
import Tournament from '../pages/Tournament';
import ImportTournamentResults from "../pages/ImportTournamentResults/";
import Rulebook from '../pages/Rulebook';
import Byes from '../pages/Byes';
import Dashboard from '../pages/Dashboard';
import RoutedAddStage from '../pages/AddStage';
import Deck from '../pages/Deck';
import Home from '../pages/Home';
import FindLeague from '../pages/FindLeague';
import { AnimatePresence } from "motion/react";

function PrivateRoutes(props) {
    const location = useLocation();

    return (
        <AnimatePresence>
            <Routes basename={props.basepath} location={location} key={location.pathname}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/seasons" element={<Seasons />} />
                <Route path="/leagues" element={<Leagues />} />
                <Route path="/find-league" element={<FindLeague />} />
                <Route path="/full-tournaments" element={<Tournaments />} />
                <Route path="/tournaments/:id" element={<Tournament hasRights={props.hasRights} />} />
                <Route path="/tournaments/:id/import-results" element={<ImportTournamentResults />} />
                <Route path="/tournaments/" element={<FilteredTournaments />} />
                <Route path="/rankings" element={<Ranking />} />
                <Route path="/seasons/:id" element={<Season />} />
                <Route path="/seasons/:id/addstage" element={<RoutedAddStage />} />
                <Route path="/stages/:id" element={<Stage />} />
                <Route path="/stages/:id/import-results" element={<ImportStageResults />} />
                <Route path="/players/:id" element={<Player />} />
                <Route path="/leagues/:id" element={<League />} />
                <Route path="/decks/:id" element={<Deck />} />
                <Route path="/rulebook" element={<Rulebook />} />
                <Route path="/byes" element={<Byes />} />
                <Route path="/home" element={<Home />} />
                <Route path="*" element={<Navigate to="/home" />} />
            </Routes>
        </AnimatePresence>
    )
}

export default PrivateRoutes;